// Mock data for the admin dashboard
export const mockData = {
  stats: {
    totalTransports: 1247,
    activeTransports: 23,
    totalClients: 156,
    monthlyRevenue: 45620
  },
  recentTransports: [
    {
      id: 'T001',
      client: 'MedLife Cluj',
      route: 'Cluj-Napoca → București',
      status: 'in_transit',
      date: '2024-07-26',
      value: 2500,
      driverPhone: '+40745123456'
    },
    {
      id: 'T002', 
      client: 'Sanovil',
      route: 'Dej → Timișoara',
      status: 'completed',
      date: '2024-07-25',
      value: 1800,
      driverPhone: '+40745234567'
    },
    {
      id: 'T003',
      client: 'Gebrüder Weiss',
      route: 'Cluj-Napoca → Vienna',
      status: 'pending',
      date: '2024-07-26',
      value: 3200,
      driverPhone: '+40745345678'
    }
  ],
  clients: [
    {
      id: 1,
      name: 'MedLife',
      email: 'contact@medlife.ro',
      phone: '+40 21 9632',
      transports: 45,
      totalValue: 125000
    },
    {
      id: 2,
      name: 'Clinica Sanovil', 
      email: 'office@sanovil.ro',
      phone: '+40 264 123',
      transports: 28,
      totalValue: 87500
    },
    {
      id: 3,
      name: 'Gebrüder Weiss',
      email: 'cluj@gw-world.com',
      phone: '+40 264 456',
      transports: 67,
      totalValue: 198000
    }
  ],
  partners: [
    {
      id: 1,
      name: "MedLife",
      sector: "Servicii Medicale",
      colaborareDin: "2020",
      tipParteneriat: "Strategic",
      status: "active"
    },
    {
      id: 2,
      name: "Gebrüder Weiss",
      sector: "Transport & Logistică", 
      colaborareDin: "2019",
      tipParteneriat: "Internațional",
      status: "active"
    },
    {
      id: 3,
      name: "Clinica Sanovil",
      sector: "Servicii Medicale",
      colaborareDin: "2021", 
      tipParteneriat: "Regional",
      status: "active"
    }
  ]
};